<template>
	<div class="page-in">
		<van-nav-bar :title="$t('我的订单')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<div class="layui-container">
				<div class="agency-panel" v-if="myData && myData != ''">
					<div class="agency-grid">
						<div class="head-avatar"><img :src="$store.state.userInfo.avatar && $store.state.userInfo.avatar != '' ? $store.state.userInfo.avatar : require('@/assets/images/head.png')" alt=""></div>
						<div class="flex-col">
							<div class="t-name">{{$t('嗨')}} {{myData.level_name}} {{myData.user_name}}</div>
						</div>
					</div>
					<div class="agency-data order-row-data">
						<div class="col">
							<div class="agency-label">{{$t('已购买的商品')}}</div>
							<div class="agency-val">{{myData.order_num}} </div>
						</div>
						<div class="col">
							<div class="agency-label">{{$t('我喜欢的商品')}}</div>
							<div class="agency-val">{{myData.collect_num}} </div>
						</div>
						<div class="col">
							<div class="agency-label">{{$t('购物车的商品')}}</div>
							<div class="agency-val">{{myData.shopping_count}}</div>
						</div>
						<div class="col">
							<div class="agency-label">{{$t('浏览过的商品')}}</div>
							<div class="agency-val">{{myData.record_num}}</div>
						</div>
					</div>
				</div>
				<div class="order-tabs">
					<el-tabs v-model="order_status" @tab-click="handleClick">
						<el-tab-pane :label="$t('所有订单')" name="9"></el-tab-pane>
						<el-tab-pane :label="$t('待付款')" name="0"></el-tab-pane>
						<el-tab-pane :label="$t('待发货')" name="1"></el-tab-pane>
						<el-tab-pane :label="$t('待收货')" name="2"></el-tab-pane>
						<el-tab-pane :label="$t('待评价')" name="3"></el-tab-pane>
						<el-tab-pane :label="$t('已完成')" name="4"></el-tab-pane>
						<el-tab-pane :label="$t('已取消')" name="5"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="order-search flex">
					<div class="flex-col">
						<el-input :placeholder="$t('订单号/商品名称')" v-model="searcname">
						</el-input>
					</div>
					<el-button class="btn-j" type="primary" @click="searchOrder" round>{{$t('搜索订单')}}</el-button>
				</div>
				<!-- 手机 -->
				<template v-if="isMobileFlag">
					<div class="order-cells">
						<div class="order-card" v-for="(item,index) in orderData">
							<div class="order-card-head">
								<div class="td-filter">
									<span>ID：{{item.order_sn}}</span>
									<span>{{item.created_at}}</span>
								</div>
							</div>
							<div class="order-card-body">
								<div class="td-goods" @click="getProductGetUrl(item)">
									<div class="td-goods-photo">
										<img :src="item.goods_pic"
											alt="" /></div>
									<div class="flex-col">
										<div class="td-goods-title">
											{{item.goods_name}}
										</div>
										<div class="td-goods-item">{{$t('价格')}}：{{formatNumber(item.goods_price)}} VND</div>
										<div class="goods-item-flex">
											<div class="flex-col">
												<div class="td-goods-item">{{$t('规格')}}：{{item.sku}}</div>
											</div>
											<div class="td-goods-item">{{$t('数量')}}：{{item.num}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="order-card-foot">
								<div>
									<span v-if="item.status == 0" class="text-primary">{{$t('待付款')}}</span>
									<span v-else-if="item.status == 1" class="text-primary">{{$t('待发货')}}</span>
									<span v-else-if="item.status == 2" class="text-warning">{{$t('待收货')}}</span>
									<span v-else-if="item.status == 3" class="text-primary">{{$t('待评价')}}</span>
									<span v-else-if="item.status == 4" class="text-gray">{{$t('已完成')}}</span>
									<span v-else-if="item.status == 5" class="text-danger">{{$t('已取消')}}</span>
									
									(<span v-if="item.pay_type == 1" >{{$t('在线支付')}}</span>
									<span v-if="item.pay_type == 2" >{{$t('货到付款')}}</span>
									<span v-if="item.pay_type == 3" >{{$t('银行转账')}}</span>)
								</div>
								<div>
									<template v-if="item.status == 0">
										<div class="btn-div" v-if="item.pay_type == 3"><el-button @click="onPayShow()" round type="primary">{{$t('立即付款')}}</el-button></div>
										<div class="btn-div" v-else><el-button @click="onPay(item.id)" round type="primary">{{$t('立即付款')}}</el-button></div>
										<div class="btn-div" v-if="$store.state.isLoginStatu"><el-button  @click="getOrderCancel(item.id)" round >{{$t('取消订单')}}</el-button></div>
									</template>
									
									<div class="btn-div" v-else-if="item.status == 2 && item.pay_type == 1"><el-button  @click="confirmOrder(item.id)" round>{{$t('确认收货')}}</el-button></div>
									<div class="btn-div" v-else-if="item.status == 2 && item.pay_type == 3"><el-button  @click="confirmOrder(item.id)" round>{{$t('确认收货')}}</el-button></div>
									<div class="btn-div" v-else-if="item.status == 3"><el-button  round @click="goComment(item.id,item.gid)">{{$t('去评价')}}</el-button></div>
									
									<div class="btn-div"><el-button  @click="getOrderDetail(item.id)" round >{{$t('订单详情')}}</el-button></div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<!-- pc -->
				<template v-else>
					<div class="order-table" v-if="orderData && orderData.length > 0">
						<table class="layui-table layui-align-center">
							<colgroup>
								<col>
								<col>
								<col>
								<col>
								<col>
								<col>
							</colgroup>
							<thead>
								<tr>
									<th>{{$t('商品')}}</th>
									<th>{{$t('单价')}}</th>
									<th>{{$t('数量')}}</th>
									<th>{{$t('付款金额')}}</th>
									<th>{{$t('支付方式')}}</th>
									<th>{{$t('交易状态')}}</th>
									<th>{{$t('交易操作')}}</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(item,index) in orderData" >
									<tr>
										<td colspan="7">
											<div class="td-filter">
												<span>{{$t('订单编号')}}：{{item.order_sn}}</span>
												<span>{{$t('下单时间')}}：{{item.created_at}}</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="td-goods" @click="getProductGetUrl(item)">
												<div class="td-goods-photo"><img :src="item.goods_pic"
														alt="" /></div>
												<div class="flex-col">
													<div class="td-goods-title">
														{{item.goods_name}}
													</div>
													<div class="td-goods-item">{{$t('规格')}}：{{item.sku}}</div>
												</div>
											</div>
										</td>
										<td>{{formatNumber(item.goods_price)}} VND</td>
										<td>{{item.num}}</td>
										<td>
											<div>{{formatNumber(item.goods_price * item.num - item.coupon_price - item.integral_price)}} VND</div>
											<div class="integral_price" v-if="item.integral_price > 0">
												{{$t('积分抵扣')}}: {{formatNumber(item.integral_price)}} VND
											</div>
											<div class="integral_price" v-if="item.coupon_price > 0">
												{{$t('优惠券减免')}}: {{formatNumber(item.coupon_price)}} VND
											</div>
										</td>
										<td>
											<span v-if="item.pay_type == 1" >{{$t('在线支付')}}</span>
											<span v-if="item.pay_type == 2" >{{$t('货到付款')}}</span>
											<span v-if="item.pay_type == 3" >{{$t('银行转账')}}</span>
										</td>
										<td>
											<span v-if="item.status == 0" class="text-primary">{{$t('待付款')}}</span>
											<span v-else-if="item.status == 1" class="text-primary">{{$t('待发货')}}</span>
											<span v-else-if="item.status == 2" class="text-warning">{{$t('待收货')}}</span>
											<span v-else-if="item.status == 3" class="text-primary">{{$t('待评价')}}</span>
											<span v-else-if="item.status == 4" class="text-gray">{{$t('已完成')}}</span>
											<span v-else-if="item.status == 5" class="text-danger">{{$t('已取消')}}</span>
											
										</td>
										<td>
												<template v-if="item.status == 0">
													<div class="btn-div" v-if="item.pay_type == 3"><el-button @click="onPayShow()" round type="primary">{{$t('立即付款')}}</el-button></div>
													<div class="btn-div" v-else><el-button @click="onPay(item.id)" round type="primary">{{$t('立即付款')}}</el-button></div>
													<div class="btn-div" v-if="$store.state.isLoginStatu"><el-button  @click="getOrderCancel(item.id)" round >{{$t('取消订单')}}</el-button></div>
												</template>
												<div class="btn-div" v-else-if="item.status == 2 && item.pay_type == 1"><el-button  @click="confirmOrder(item.id)" round>{{$t('确认收货')}}</el-button></div>
												<div class="btn-div" v-else-if="item.status == 2 && item.pay_type == 3"><el-button  @click="confirmOrder(item.id)" round>{{$t('确认收货')}}</el-button></div>
												<div class="btn-div" v-else-if="item.status == 3"><el-button  round @click="goComment(item.id,item.gid)">{{$t('去评价')}}</el-button></div>
												
												<div class="btn-div"><el-button  @click="getOrderDetail(item.id)" round >{{$t('订单详情')}}</el-button></div>
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</template>
				<div class="ui-page" v-if="listTotal > 10">
					<el-pagination background :small="isMobileFlag" :pager-count="5" layout="prev, pager, next"
						:current-page.sync="currentPage" @current-change="handleSizeChange" :page-size="listLimit"
						:total="listTotal"></el-pagination>
				</div>
			</div>
		</div>
		<payDialog :payids="String(payids)" ref="payDialog"></payDialog>
		<payBankDialog :isOrderPage="true" ref="payBankDialog"></payBankDialog>
	</div>
</template>
<script>
	import payBankDialog from "./components/payBankDialog.vue"
	import payDialog from "@/components/payDialog"
	import helper from '@/common/helper.js';
	import {
		order_list_api,
		order_cancel_api,
		order_confirm_api,
		order_pay_api,
	} from "@/api/user"
	export default {
		components: {
			payDialog,
			payBankDialog,
		},
		data() {
			return {
				checkAll: false,
				searcname: '',
				order_status: '9',
				orderData: [],
				currentPage: 1,
				listPage: 1,
				listLimit: 10,
				listTotal: 0,
				myData:null,
				payids:""
			};
		},
		methods: {
			onPayShow(){
				this.$refs.payBankDialog.payInfoShow = true
			},
			getProductGetUrl(item) {
				if (item.gid) {
					this.$router.push({
						path: '/product-detail',
						query: {
							id: item.gid
						}
					});
				} else if (item.id) {
					// 如果 item.gid 不存在，再判断 item.id
					this.$router.push({
						path: '/product-detail',
						query: {
							id: item.id
						}
					});
				}
			},
			handleClick(tab, event) {
				this.searcname = ""
				this.getOrderData()
			},
			searchOrder(){
				if (this.searcname == "") {
					this.errorTips("订单号/商品名称");
					return false;
				}
				this.getOrderData()
			},
			async onPay(orderid) {
				let data = {
					id: orderid,
				}
				if(!this.$store.state.isLoginStatu){
					data["uuid"] = helper.get('uuid') || ''
				}
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_pay_api(data).then(res => {
					loading.close();
					if (res && res.data.code == 1) {
						this.platUrl(res.data.data)
					}else{
						this.errorTips(res.data.msg)
					}
				});
			},
			async confirmOrder(oid) {
				await this.$confirm(this.$t('是否要确认收货?'), '', {
					confirmButtonText: this.$t('确定'),
					cancelButtonText: this.$t('取消'),
					type: 'warning'
				}).then(() => {
					let param = {
						id: oid,
					};
					if(!this.$store.state.isLoginStatu){
						param["uuid"] = helper.get('uuid') || ''
					}
					const loading = this.$loading({
						lock: true,
						text: '',
						spinner: 'loader',
						background: 'rgba(255, 255, 255, 0.3)'
					});
					order_confirm_api(param).then(res => {
						loading.close();
						if (res && res.data.code == 1) {
							this.getOrderData()
							this.successTips(res.data.msg)
						} else {
							this.errorTips(res.data.msg)
						}
					});
				}).catch(() => {});
			},
			async getOrderData() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				try {
					let param = {
						page: this.listPage,
						limit: this.listPage == 1 ? 10 : this.listLimit,
						order_sn: this.order_sn,
						order_status: this.order_status,
						goods_name: this.goods_name,
						searcname: this.searcname,
						start_time: this.start_time,
						end_time: this.end_time,
					};
					if(!this.$store.state.isLoginStatu){
						param["uuid"] = helper.get('uuid') || ''
					}
					if (this.order_status == '9') {
						param['order_status'] = '';
					}else{
						param['order_status'] = this.order_status;
					}
					const res = await order_list_api(param);
					if (res && res.data.code == 1) {
						this.orderData = res.data.data.list;
						this.listTotal = res.data.data.total;
						loading.close();
					}else if(res && res.data.code == -1){
						this.goLogin()
					}
				} catch (error) {
					console.error('', error);
				}
			},
			getOrderDetail(aid){
				this.$router.push({ 
				  path: '/order-detail', 
				  query: {
					  aid: aid,
				  }
				})
			},
			goComment(aid,gid){
				this.$router.push({ 
				  path: '/product-comment', 
				  query: {
					  aid: aid,
					  gid: gid
				  }
				})
			},
			async getOrderCancel(oid) {
				await this.$confirm(this.$t('是否要删除订单?'), '', {
					confirmButtonText: this.$t('确定'),
					cancelButtonText: this.$t('取消'),
					type: 'warning'
				}).then(() => {
					let param = {
						id: oid,
					};
					const loading = this.$loading({
						lock: true,
						text: '',
						spinner: 'loader',
						background: 'rgba(255, 255, 255, 0.3)'
					});
					order_cancel_api(param).then(res => {
						loading.close();
						if (res && res.data.code == 1) {
							this.getOrderData()
							this.successTips('订单删除成功')
						} else {
							this.errorTips(res.data.msg)
						}
					});
				}).catch(() => {});
			},
			handleSizeChange(e) {
				this.listPage = e;
				this.getOrderData();
			},
		},
		mounted() {
			if(helper.get("userInfo") != ""){
				this.myData = helper.get("userInfo")
			}
			this.getOrderData();
		}
	};
</script>
<style scoped>
	.agency-grid .head-avatar img {
		width: 60px;
		height: 60px;
	}

	.td-goods {
		display: flex;
		align-items: center;
		text-align: left;
		max-width: 360px;
		word-break: break-all;
	}

	.td-goods-photo {
		font-size: 0;
		margin-right: 20px;
	}

	.td-goods-photo img {
		width: 120px;
		height: 120px;
	}

	.td-goods-title {
		margin-bottom: 10px;
		font-size: 16px;
	}
	.order-cells{
		padding: 15px 0;
	}
	.order-card{
		border-radius: 4px;
		padding: 0 15px;
		box-shadow: 0 1px 5px rgba(0, 0, 0, .1);
		margin-bottom: 12px;
	}
	.order-card-head{
		padding: 15px 0;
		font-size: 12px;
		border-bottom: 1px solid rgba(0, 0, 0, .1);
	}
	.order-card-body{
		padding: 15px 0;
	}
	.order-card-foot{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px 0;
		border-top: 1px solid rgba(0, 0, 0, .1);
	}
	.order-card-foot .el-button{
		padding: 8px 12px;
		font-size: 13px;
	}
	.order-card-body .td-goods-photo img{
		width: 80px;
		height: 80px;
	}
	.order-card-body .td-goods-title{
		font-size: 14px;
	}
	.goods-item-flex{
		display: flex;
		font-size: 12px;
	}
	.goods-item-flex >.td-goods-item{
		margin-left: 10px;
	}
	.agency-data .col{
		padding: 0 15px;
	}
	
	@media (max-width:992px) {
		.order-row-data{
			flex-wrap: wrap;
		}
		.order-row-data .col{
			flex: unset;
			width: 50%;
			padding: 10px 0;
		}
		.agency-data .col:nth-child(even){
			border-right: 0;
		}
	}
	.btn-div{
		padding: 5px 0;
	}
	.integral_price{
		text-decoration: line-through;
		color: #ff0000;
		font-size: 12px;
		margin-top: 5px;
	}
	
</style>